// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Jamaica from '../_raw/flag/icon_flag_jamaica.png';

export default () => <img src={Jamaica} alt="Jamaica" />;
